import React from 'react';
import type { IconProps } from '../types';

export const Checked = (props: IconProps) => (
  <svg
    {...props}
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 9L9.3333 15L6 12.4737"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Checked;
